export enum InternalTransferFormField {
  TO = 'to',
  FROM = 'from',
  AMOUNT = 'amount',
  PAYMENT_OPTION = 'paymentOption',
  TRANSFER_TYPE = 'transferType',
  SCHEDULED_DATE = 'scheduledDate',
  RECURRING_START_DATE = 'recurringStartDate',
  RECURRING_START_DATE_1 = 'recurringStartDate1',
  RECURRING_START_DATE_2 = 'recurringStartDate2',
  RECURRING_TYPE = 'recurringType',
  RECURRING_NUMBER = 'recurringNumber',
  RECURRING_END_DATE = 'recurringEndDate',
  MEMO = 'memo',
  ACCOUNT_NUMBER = 'accountNumber',
  ROUTING_NUMBER = 'routingNumber',
  AGREEMENT_ACCEPTED = 'agreementAccepted',
}
